import {StateType} from './stateType';

export const getExpectedSpec = (
  expectedPanels: StateType,
  key: string | null
) => {
  if (!expectedPanels) {
    return;
  }
  if (!key) {
    return;
  }
  return expectedPanels.defaultSpecs[key] ?? expectedPanels.apiAddedSpecs[key];
};

export const getNumExpectedSpecs = (expectedPanels: StateType) => {
  if (!expectedPanels) {
    return 0;
  }
  const {defaultSpecs, apiAddedSpecs} = expectedPanels;
  const numDefaultSpecs = Object.keys(defaultSpecs).length;
  const numApiAddedSpecs = Object.keys(apiAddedSpecs).length;
  return numDefaultSpecs + numApiAddedSpecs;
};
